/*
 * File: cc-cell-item-extra-fields-form.component.ts                           *
 * Project: catalog-cloud                                                      *
 * File Created: Friday, 27th May 2022 09:15:01                                *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Wednesday, 7th December 2022 10:06:28                        *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { Component, Input, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilder } from '@angular/forms';
import { CellService } from 'app/modules/catalog-cloud/services/cell.service';

import { Cell, ProductExtra } from '@nousmedis/cc-types';
import { MessageService } from 'primeng/api';
import { ProductService } from 'app/modules/catalog-cloud/services/product.service';
import { PageService } from 'app/modules/catalog-cloud/services/page.service';

@Component({
  selector: 'app-cc-cell-item-extra-fields-form',
  templateUrl: './cc-cell-item-extra-fields-form.component.html',
  styleUrls: ['./cc-cell-item-extra-fields-form.component.scss'],
})
export class CcCellItemExtraFieldsFormComponent implements OnInit {
  entity: ProductExtra[];
  private idCatalog: string;
  private idFascicle: string;
  private idPage: string;
  private idCell: string;
  private cell: Cell;

  constructor (
    private dialogRef: DynamicDialogRef,
    private dialogConf: DynamicDialogConfig,
    private cellService: CellService,
    private msgService: MessageService,
    private productService: ProductService,
    private pageService: PageService
  ) {
    this.entity = dialogConf.data.entity || [];
    this.idCatalog = dialogConf.data.idCatalog;
    this.idFascicle = dialogConf.data.idFascicle;
    this.idPage = dialogConf.data.idPage;
    this.idCell = dialogConf.data.idCell;
    this.cell = dialogConf.data.cell;


  }

  ngOnInit(): void { }

  cancelField(): void {
    this.dialogRef.close();
  }

  saveField(): void {


    if (!this.cell.productExtra) {
      this.cell.productExtra = [];
    }

    this.cell.productExtra = this.entity;



    this.cellService
      .update(
        this.idCatalog,
        this.idFascicle,
        this.idPage,
        this.idCell,
        this.cell
      )
      .subscribe((data) => {
        this.pageService.reloadGrid$.next(true);
        this.msgService.add({
          key: 'root-msg',
          detail: 'Celda actualizada',
          severity: 'success',
        });

        this.dialogRef.close();
      });
  }
}
